import { string, object } from "yup"

export const FORM_KEYS = {
    FIRST_NAME: "first_name",
    LAST_NAME: "last_name",
    PHONE: "phone",
    EMAIL: "email",
} as const

export function useSchema() {
    return object({
        [FORM_KEYS.FIRST_NAME]: string().required(),
        [FORM_KEYS.LAST_NAME]: string().required(),
        [FORM_KEYS.PHONE]: string().required(),
        [FORM_KEYS.EMAIL]: string().required(),
    })
}
